import React from 'react'
import PropTypes from 'prop-types'
import {
  makeStyles,
  TextField, Grid, MenuItem, Button, Box, Checkbox,
  FormControlLabel, Typography, Dialog,
  //  DialogTitle,
  DialogContent, DialogActions,
} from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import * as Yup from 'yup'
import {
  Link,
} from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
// import jmoment from 'moment-jalaali'
import { withStyles } from '@material-ui/core/styles'
import { orange } from '@material-ui/core/colors'
import {
  useDispatch,
} from 'react-redux'
import {
} from '../../../app/slices/loadingSlice'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import { registerUser } from '../../../app/slices/userSlice'
import { fixNumbers } from '../../../utils/getInitials'
import './Register.css'
import CustomToolbar from '../../../utils/CustomToolbar'

export const RegistererTypes = [
  { label: 'parents', value: 1 },
  { label: 'father', value: 2 },
  { label: 'mother', value: 3 },
  { label: 'student', value: 4 },
]

export const sexType = [
  { label: 'man', value: 1 },
  { label: 'woman', value: 2 },
]

const initialValues = {
  username: '',
  firstName: '',
  lastName: '',
  // sex: 'man',
  // birthDate: jmoment(),
  birthDate: null,
  password: '',
  passwordConfirm: '',
  phoneNumber: '',
  registerer: '',
  policy: false,
}

const GreenCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const validationSchema = (t) => Yup.object().shape({
  username: Yup.string()
    .length(10, t('must_be_exactly_ten_characters'))
    .required(`${t('username')} ${t('required')}`).max(11),
  firstName: Yup.string()
    .required(`${t('firstName')} ${t('required')}`),
  lastName: Yup.string()
    .required(`${t('lastName')} ${t('required')}`),
  birthDate: Yup.object()
    .required(`${t('birthDate')} ${t('required')}`)
    .typeError(`${t('birthDate')} ${t('required')}`),
  password: Yup.string()
    .min(8, t('passwordـmustـbeـatـleast_eight_characters'))
    .max(255)
    .required(`${t('password')} ${t('required')}`),
  passwordConfirm: Yup.string()
    .min(8, t('passwordـmustـbeـatـleast_eight_characters'))
    .max(255)
    .required(`${t('repeat')} ${t('password')} ${t('required')}`)
    .oneOf(
      [Yup.ref('password'), null],
      t('password_and_its_repetition_must_be_the_same'),
    ),
  phoneNumber: Yup.string()
    .length(11, t('must_be_exactly_eleven_characters'))
    .required(`${t('mobile_number')} ${t('required')}`),
  registerer: Yup.string()
    .required(`${t('registerer')}`),
  policy: Yup.bool().oneOf([true], 'error'),
})

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    '& .MuiButton-text': {
      padding: 0,
    },
    '& .MuiButton-root': {
      padding: 0,
    },
  },
  datePicker: {
    '& .MuiPickersDatePickerRoot-toolbar': {
      backgroundColor: 'orange !important',
    },
    '& h6.MuiPickersToolbarText-toolbarTxt': {
      color: '#fff !important',
      fontSize: '20px',
      '&::after': {
        content: ' " انتخاب سال " ',
        color: '#fff !important',
        fontSize: '13px',
      },
    },
    '& h4.MuiPickersToolbarText-toolbarTxt': {
      // display: 'none',
    },
  },
  form: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  formContainer: {
    flexGrow: 1,
  },
  titleSection: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  item: {
    height: theme.spacing(14),
    padding: theme.spacing(1.5),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',
  },
  buttonBack: {
    width: theme.spacing(20),
    marginRight: theme.spacing(2),
  },
  buttonNext: {
    width: theme.spacing(20),
  },
  buttonRegisterWrap: {
    width: '100%',
    margin: '10px auto 0 auto',
    display: 'flex',
    alignSelf: 'center',
  },
  buttonRegister: {
    width: '80%',
    height: '64px',
    color: '#ffffff',
    backgroundColor: '#f9b233',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    margin: '0 auto',
    borderRadius: '10px',

  },
  customInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '5px',
    width: '100%',

  },
  customInput2: {
    display: 'block',
    marginTop: '5px',
    padding: '0',
    marginRight: '0',
    width: '100%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6, 4),
    width: '40%',
    borderRadius: '20px',
    height: '70vh',
    overflow: 'hidden',
    '@media (max-width: 1400px)': {
      width: '50%',
    },
    '@media (max-width: 1200px)': {
      width: '60%',
    },
    '@media (max-width: 900px)': {
      width: '65%',
      height: '65vh',
    },
    '@media (max-width: 750px)': {
      width: '75%',
      height: '50vh',
    },
    '@media (max-width: 600px)': {
      width: '80%',
      height: '45vh',
    },
    '@media (max-width: 400px)': {
      width: '85%',
      height: '42vh',
    },
  },
  modalContent: {
    width: '100%',
    height: '100%',
    overflowY: 'scroll',
    boxSizing: 'content-box',
    paddingRight: '32px',
  },
  modalDesc: {
    fontSize: '18px',
    marginTop: '25px',
    whiteSpace: 'pre-line',
    marginBottom: '25px',
    lineHeight: '1.6',
    textAlign: 'justify',
    '@media (max-width: 960px)': {
      fontSize: '16',
    },
    '@media (max-width: 600px)': {
      fontSize: '14px',
    },
  },
  modalTitle: {
    marginTop: '20px',
    '@media (max-width: 960px)': {
      fontSize: '20px',
    },
    '@media (max-width: 600px)': {
      fontSize: '16px',
    },
  },
  registerFormSectionWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    overflow: 'auto',
  },
  checkboxError: {
    display: 'block',
    clear: 'both',
    color: '#f44336',
    fontSize: '12px',
    fontWeight: '400',
  },
  dateWarning: {
    '& .MuiDialog-paperWidthSm': {
      width: '80%',
      height: '220px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#f9b233',
      margin: '22px 20.6px 36px 20.5px',
    },
  },
  dateWarningBtn: {
    backgroundColor: '#ffffff',
    width: '20%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #fff',
    fontSize: '1rem',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  dialogContentRoot: {
    fontSize: '1.4em',
    fontWeight: 600,
    color: '#fff',
    padding: '70px 20px 0',
  },
}))

const FormStep = ({
  setActiveStep,
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [dateWarn, setDateWarn] = React.useState(false)

  const handleOpen = (e) => {
    e.stopPropagation()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = (fields) => {
    const data = {
      userName: fields.username,
      password: fields.password,
      profile: {
        phoneNumber: fields.phoneNumber,
        birthDate: fixNumbers(fields.birthDate.format('YYYY-MM-DD')),
        Registerer: fields?.registerer,
        firstName: fields.firstName,
        lastName: fields.lastName,
      },
    }

    dispatch(registerUser(t, data, () => setActiveStep(1)))
  }

  const openWarnModal = () => {
    setDateWarn(true)
  }

  return (
    <Grid item xs={12} sm={12} className={classes.root}>
      <Box className="main-new_register">
        <Box
          className="register-image-warp"
          style={{ height: '100%' }}
        >
          <img
            style={{ height: '100%' }}
            src="images/register.png"
            className="new-register-image"
            alt="Login"
          />

        </Box>
        <div className={classes.registerFormSectionWrapper}>
          <Grid className="form_section1">
            <Box
              display="flex"
              justifyContent="center"
              className="new_register_form-section"
            >
              <img
                src="images/logo.svg"
                style={{ width: '180px', height: 'auto', margin: '80px auto 70px' }}
                alt="logo"
              />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema(t)}
                onSubmit={(fields) => handleSubmit(fields)}
                enableReinitialize
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  setFieldValue,
                }) => {
                  return (
                    <Form className={classes.form}>
                      <Grid classes={{ root: classes.formContainer }}>
                        <Grid
                          container
                          justify="center"
                          direction="row"
                          alignItems="center"
                          style={{ margin: '0 auto' }}
                          classes={{ root: classes.root }}
                        >

                          <Grid
                            className="new_register_form-field"
                            item
                            xs={10}
                            sm={10}
                            classes={{ root: classes.item }}
                          >
                            <label className="new_register_form-label" htmlFor="username">
                              {`${t('national_code')}`}
                              {' '}
                              (آزمون دهنده)
                              *
                            </label>
                            <TextField
                              id="username"
                              className={classes.customInput}
                              error={Boolean(touched.username && errors.username)}
                              fullWidth
                              dir="rtl"
                              InputLabelProps={{ dir: 'ltr' }}
                              helperText={touched.username && errors.username}
                              margin="normal"
                              name="username"
                              onBlur={handleBlur}
                              onChange={(e) => (e.target.validity.valid ? handleChange(e) : null)}
                              type="text"
                              value={values.username}
                              variant="outlined"
                              inputProps={{
                                maxLength: 10,
                                pattern: '[0-9]*',
                                style: { width: '100%' },
                              }}
                              autoFocus
                            />
                          </Grid>

                          <Grid
                            item
                            xs={10}
                            sm={5}
                            classes={{ root: classes.item }}
                          >
                            <label
                              className="new_register_form-label"
                              htmlFor="name"
                            >
                              {`${t('firstName')}`}
                              {' '}
                              (آزمون دهنده)
                              *
                            </label>
                            <TextField
                              className={classes.customInput}
                              id="firstName"
                              error={Boolean(touched.firstName && errors.firstName)}
                              fullWidth
                              helperText={touched.firstName && errors.firstName}
                              margin="normal"
                              name="firstName"
                              onBlur={handleBlur}
                              onChange={(e) => (e.target.validity.valid ? handleChange(e) : null)}
                              type="text"
                              value={values.firstName}
                              variant="outlined"
                              dir="rtl"
                            />
                          </Grid>
                          <Grid
                            item
                            xs={10}
                            sm={5}
                            classes={{ root: classes.item }}
                          >
                            <label
                              className="new_register_form-label"
                              htmlFor="lastName"
                            >
                              {`${t('lastName')}`}
                              {' '}
                              (آزمون دهنده)
                              *
                            </label>
                            <TextField
                              className={classes.customInput}
                              id="lastName"
                              error={Boolean(touched.lastName && errors.lastName)}
                              fullWidth
                              helperText={touched.lastName && errors.lastName}
                              margin="normal"
                              name="lastName"
                              onBlur={handleBlur}
                              onChange={(e) => (e.target.validity.valid ? handleChange(e) : null)}
                              type="text"
                              value={values.lastName}
                              variant="outlined"
                              dir="rtl"
                            />
                          </Grid>

                          <Grid
                            item
                            xs={10}
                            sm={5}
                            classes={{ root: classes.item }}
                          >
                            <label
                              className="new_register_form-label"
                              htmlFor="mobile"
                            >
                              {`${t('mobile_number_register')}`}
                              {' '}
                              (آزمون دهنده)
                              *
                            </label>
                            <TextField
                              className={classes.customInput}
                              id="mobile"
                              error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                              fullWidth
                              helperText={touched.phoneNumber && errors.phoneNumber}
                              margin="normal"
                              name="phoneNumber"
                              onBlur={handleBlur}
                              onChange={(e) => (e.target.validity.valid ? handleChange(e) : null)}
                              type="text"
                              value={values.phoneNumber}
                              variant="outlined"
                              dir="rtl"
                              InputLabelProps={{ dir: 'ltr' }}
                              inputProps={{
                                maxLength: 11,
                                pattern: '[0-9]*',
                                style: { width: '100%' },
                              }}
                            />
                          </Grid>

                          <Grid item xs={10} sm={5} classes={{ root: classes.item }}>
                            <label htmlFor="birthday">
                              {t('birthday')}
                              {' '}
                              (آزمون دهنده)
                              *
                            </label>
                            <DatePicker
                              className={classes.customInput2}
                              id="birthday"
                              // toolbarFormat="YYYY/MM/DD"
                              name="birthDate"
                              okLabel={(
                                <span
                                  style={{ width: '70px', height: 'inherit' }}
                                  onClick={openWarnModal}
                                >
                                  {t('confirm')}
                                </span>
)}
                              cancelLabel={t('cancel')}
                              clearLabel={t('clean')}
                              inputVariant="outlined"
                              clearable
                              fullWidth
                              margin="normal"
                              todayLabel
                              variant="dialog"
                              // orientation="landscape"
                              labelFunc={(date) => (date?.isValid ? date.format('jYYYY/jMM/jDD') : '')}
                              value={values.birthDate}
                              // format="DD-MM-YYYY"
                              dir="rtl"
                              InputLabelProps={{ dir: 'rtl' }}
                              ToolbarComponent={CustomToolbar}
                              onClick={openWarnModal}
                              onChange={(e) => {
                                // setDateWarn(true)
                                setFieldValue('birthDate', e)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onClick={openWarnModal}
                                  inputProps={
                                    {
                                      ...params.inputsProps,
                                      placeholder: 'jYYYY/jMMMM/jDD',
                                    }
                                  }
                                />
                              )}
                              DialogProps={{
                                className: classes.datePicker,
                              }}
                              error={Boolean(touched.birthDate && errors.birthDate)}
                              helperText={touched.birthDate && errors.birthDate}
                              // open={openWarnModal}
                            />
                          </Grid>

                          <Grid
                            className="new_register_form-field"
                            item
                            xs={10}
                            sm={10}
                            classes={{ root: classes.item }}
                          >
                            <label
                              className="new_register_form-label"
                              htmlFor="registrant"
                            >
                              {t('registrant')}
                              *
                            </label>
                            <TextField
                              className={classes.customInput}
                              id="registrant"
                              error={Boolean(touched.registerer && errors.registerer)}
                              select
                              fullWidth
                              helperText={touched.registerer && errors.registerer}
                              margin="normal"
                              name="registerer"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type="text"
                              value={values.registerer}
                              variant="outlined"
                              InputProps={{
                              }}
                            >
                              {RegistererTypes.map((registerer) => (
                                <MenuItem key={registerer.value} value={registerer.value}>
                                  {t(registerer.label)}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={5} sm={5} classes={{ root: classes.item }}>
                            <label htmlFor="password">
                              {t('password')}
                              *
                            </label>
                            <TextField
                              className={classes.customInput2}
                              id="password"
                              error={Boolean(touched.password && errors.password)}
                              fullWidth
                              dir="rtl"
                              InputLabelProps={{ dir: 'ltr' }}
                              helperText={touched.password && errors.password}
                              margin="normal"
                              name="password"
                              placeholder="*******"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type="password"
                              value={values.password}
                              variant="outlined"
                              InputProps={{
                              }}
                            />
                          </Grid>
                          <Grid item xs={5} sm={5} classes={{ root: classes.item }}>
                            <label
                              htmlFor="passwordConfirm"
                            >
                              {`${t('repeat')} ${t('password')}`}
                              *
                            </label>
                            <TextField
                              id="passwordConfirm"
                              className={classes.customInput2}
                              error={Boolean(touched.passwordConfirm && errors.passwordConfirm)}
                              fullWidth
                              dir="rtl"
                              InputLabelProps={{ dir: 'ltr' }}
                              helperText={touched.passwordConfirm && errors.passwordConfirm}
                              margin="normal"
                              name="passwordConfirm"
                              placeholder="*******"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              type="password"
                              value={values.passwordConfirm}
                              variant="outlined"
                              InputProps={{
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'flex-start',
                          flexFlow: 'column',
                          margin: '0 auto',
                        }}
                        item
                        xs={10}
                        sm={10}
                        classes={{ root: classes.item }}
                      >
                        <div style={{
                          display: 'flex',
                          alignContent: 'flex-start',
                          alignItems: 'center',
                          flexFlow: 'row',
                          // marginLeft: '100px',
                        }}
                        >
                          <FormControlLabel
                            style={{
                              display: 'flex',
                              alignContent: 'flex-start',
                              alignSelf: 'center',
                              marginRight: 0,
                              marginLeft: 0,
                            }}
                            value={values.policy}
                            control={(
                              <GreenCheckbox
                                color="primary"
                                checked={values.policy}
                                onChange={(e) => {
                                  setFieldValue('policy', e.target.checked)
                                }}
                              />
                      )}
                            labelPlacement="end"
                          />
                          <p>
                            با ایجاد حساب در این سایت من با

                            <span onClick={handleOpen} style={{ color: '#0080ff', cursor: 'pointer' }}>
                              {' '}
                              {t('policy')}
                              {' '}
                              {' '}
                            </span>
                            موافقت دارم.

                          </p>
                        </div>
                        <div>
                          <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            className={classes.modal}
                            open={open}
                            style={{ outline: 'none' }}
                            onClose={handleClose}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                              timeout: 500,
                            }}
                          >
                            <Fade in={open} style={{ outline: 'none' }}>
                              <div className={classes.paper}>
                                <div className={classes.modalContent}>
                                  <h2 className={classes.modalTitle} id="transition-modal-title">{t('policy')}</h2>
                                  <p className={classes.modalDesc} id="transition-modal-description">
                                    شرایط استفاده از خدمات
                                    <br />
                                    شرکت در آزمون استعدادیابی گارنت به منزله قبول شرایط زیر است:
                                    <br />
                                    پس از عضویت در سایت، امکان تغییر
                                    اطلاعات حساب کاربری به‌هیچ ‌عنوان وجود ندارد.
                                    <br />
                                    برای دریافت آموزش‌ها، پس از ورود در سایت، باتوجه‌به
                                    رده سنی در آزمون استعداد‌یابی شرکت می‌کنید و پس از آزمون
                                    می‌توانید دوره‌های آموزش عمومی را مشاهده کنید.
                                    <br />
                                    امکان خرید دوره‌ها تنها به‌صورت اینترنتی و با رمز دوم پویا
                                    فراهم است و خرید به‌صورت تلفنی و حضوری امکان‌پذیر نیست.
                                    <br />
                                    کلیه خدمات گارنت شامل آزمون استعدادیابی و آموزش‌ها
                                    و ... تنها به‌صورت ویدئوهای از قبل ضبط شده و به شکل
                                    آنلاین در دسترس هستند و امکان خرید دوره‌ها به‌صورت فیزیکی
                                    Flash، Disk و DVD و آزمون حضوری میسر نیست.
                                    <br />
                                    آموزش‌های گارنت، به‌صورت ویدئوهای از
                                    پیش ضبط شده در دسترس شما هستند، برای دسترسی به
                                    کلیه خدمات، ابتدا باید در آزمون استعدادیابی شرکت کنید.
                                    <br />
                                    دسترسی شما به آزمون بلافاصله پس از خرید امکان‌پذیر است.
                                    <br />
                                    آزمون‌ها به‌صورت آنلاین هستند و در صورت
                                    تکمیل یک آزمون می‌توانید آزمون بعدی را شروع کنید.
                                    <br />
                                    (حتماً نباید در یک روز در تمام آزمون‌ها شرکت کنید.)
                                    <br />
                                    2 هفته پس از آزمون و دریافت
                                    کارنامه به آموزش‌های عمومی دسترسی پیدا خواهید کرد.
                                    <br />
                                    مدت‌زمان مشاهده آموزش‌های عمومی فقط 4 ماه و غیر قابل تمدید است.
                                    <br />
                                    ویدئوهای آموزش عمومی در بخش پنل کاربری در وب‌سایت گارنت در
                                    دسترس قرار خواهد گرفت. دسترسی به این ویدئوها به‌صورت
                                    ترتیبی و با تماشای ویدئوها برای کاربران مقدور است.
                                    <br />
                                    دسترسی به دوره‌ها محدود به هیچ روز و ساعتی نیست و شما
                                    در کلیه ساعات شبانه‌روز به‌تمامی محتوای آن‌ها دسترسی دارید.
                                    <br />
                                    هر آموزش، صرفاً مختص کسی است که در آزمون
                                    استعدادیابی شرکت کرده است و فرد تهیه‌کننده، نباید آن را
                                    به هر نحوی منتشر نماید و یا در اختیار دیگران قرار دهد.
                                    <br />
                                    آموزش‌های گارنت به‌عنوان منبع مطالعه و یادگیری فردی می‌باشند.
                                    گارنت و مدرسین مجموعه‌های آموزشی، مسئولیتی در قبال پاسخگویی به
                                    پرسش‌های علمی و موردی استفاده‌کنندگان از آموزش‌ها ندارند.
                                    <br />
                                    آموزش‌های گارنت، صرفاً برای
                                    {' '}
                                    <b>اهداف آموزشی</b>
                                    {' '}
 طراحی شده‌اند و گارنت مسئولیتی در قبال استفاده از این محتوا با اهداف غیرعلمی و غیراخلاقی ندارد.
                                    <br />
                                    شما مسئولیت فردی برای حفاظت از محرمانگی
                                    رمز و یا آدرس ایمیل خود را دارید. استفاده از گذرواژه شما
                                    توسط هر شخصی دیگر ممکن است منجر به لغو سریع دسترسی شما شود.
                                    <br />
                                    هرگونه پخش، انتشار مجدد،دانلود
                                    و آپلود کردن، انتقال، ارسال، توزیع، نمایش یا پخش در عموم
                                    تمامی محتواهای سایت. از طریق ای پی ردیابی می‌شود و هر کاربری
                                    که موارد فوق را انجام دهد مورد پیگرد قانونی قرار می‌گیرد.
                                  </p>

                                </div>

                              </div>
                            </Fade>
                          </Modal>
                        </div>
                        {Boolean(touched.policy && errors.policy && !values.policy) && (
                        <span className={classes.checkboxError}>
                          {t('policy_require')}
                        </span>
                        )}

                      </Grid>
                      <Button
                        type="submit"
                        size="large"
                        variant="contained"
                        fullWidth
                        className={classes.buttonRegister}
                      >
                        {t('register_button')}
                      </Button>
                    </Form>
                  )
                }}
              </Formik>
              <Typography
                color="textSecondary"
                variant="body1"
                style={{ margin: '15px auto 30px auto' }}
              >
                حساب کاربری دارید؟
                {' '}
                <Link
                  to="/login"
                  variant="h6"
                  style={{ color: '#f9b233', fontSize: '18px' }}
                >
                  وارد شوید
                </Link>
              </Typography>
            </Box>
          </Grid>
        </div>
      </Box>
      <Dialog
        className={classes.dateWarning}
        open={dateWarn}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle className={classes.dialogHeader}
         id="alert-dialog-title">توجه</DialogTitle> */}
        <DialogContent
          classes={{ root: classes.dialogContentRoot }}
        >
          آزمون دهنده محترم، لطفا تاریخ تولد خود را به درستی وارد کنید.
          آزمون‌های شما نسبت به رده سنی شما انتخاب می‌شوند.
          <br />
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          {/* <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
            لغو
          </Button> */}
          <Button
            onClick={() => setDateWarn(false)}
            className={classes.dateWarningBtn}
            autoFocus
          >
            تایید
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}
FormStep.label = 'receiving_information'
FormStep.propTypes = {
  setActiveStep: PropTypes.func,
}

export default FormStep
